module.exports = __webpack_public_path__ + "img/deltaT.e7f3a599.svg";